import { Link } from "react-router-dom";
import { DEMO_LP } from "../../data/portalDemo.js";

const STAGES = [
  { id: "submitted",    label: "Submitted",   description: "Documents received by Daksfirst compliance" },
  { id: "under_review", label: "Under review",description: "Compliance team is verifying your documents" },
  { id: "verified",     label: "Verified",    description: "You're cleared to commit to deals and pooled funds" }
];

export default function PortalKycStatus() {
  // Demo: derive from DEMO_LP.kycStatus
  const status = (DEMO_LP.kycStatus || "verified").toLowerCase();
  const verifiedAt = DEMO_LP.kycDate || "—";
  const stageIdx =
    status === "submitted" ? 0 :
    status === "under_review" || status === "under review" ? 1 :
    status === "verified" ? 2 : 0;

  return (
    <div className="portal-page">
      <h1 className="portal-h1">KYC status</h1>

      <section className="portal-card">
        <div className="portal-card-head">
          <h2 className="portal-h2">Verification progress</h2>
          <span className="muted small">Last updated: {verifiedAt}</span>
        </div>
        <div className="kyc-stages">
          {STAGES.map((s, i) => (
            <div key={s.id} className={"kyc-stage" + (i <= stageIdx ? " done" : "") + (i === stageIdx ? " current" : "")}>
              <div className="kyc-stage-dot">{i + 1}</div>
              <div>
                <div className="kyc-stage-label">{s.label}</div>
                <div className="muted small">{s.description}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="portal-card">
        <h2 className="portal-h2">Submitted documents</h2>
        <p className="muted">
          Your uploaded KYC documents are stored in your Box folder under <code>/KYC/</code>.
          You can review them anytime in <Link to="/portal/documents" className="portal-link">Documents</Link>,
          filtered by category &ldquo;General&rdquo; or by fund-folder &ldquo;KYC&rdquo;.
        </p>
        <div className="hero-actions spacer-s">
          <Link to="/portal/documents" className="btn btn-primary">View documents</Link>
          <Link to="/portal/onboarding/kyc" className="btn btn-ghost">Update KYC</Link>
        </div>
      </section>

      <section className="portal-card">
        <h2 className="portal-h2">What happens next</h2>
        <ol className="deal-bullets">
          <li>Once verified, you can browse the live deal pipeline and sign per-deal CA/NDAs.</li>
          <li>For deals you commit to, Daksfirst sends a Subscription Agreement via DocuSign.</li>
          <li>Quarterly NAV statements and capital account summaries appear in your Documents tab.</li>
        </ol>
      </section>
    </div>
  );
}
